import React from "react";
import { Center, Column } from "@/shared/ui/Blocks";
import { cn } from "@/shared/utils/shadcn";
import Circles from "@/shared/ui/Loaders/Circles";
import NoRights from "@/shared/widgets/NoRights";
import { TypewriterText } from "@/shared/ui/TypewriterText";

export interface ScreenContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {
  fullWidth?: boolean;
  loading?: boolean;
  loadingMessage?: string;
  permissionLocked?: boolean;
  contentClassName?: string;
}

function ScreenContainer(props: ScreenContainerProps) {
  const {
    id,
    children,
    loading,
    loadingMessage,
    fullWidth = false,
    className,
    contentClassName,
    permissionLocked = false,
    ...rest
  } = props;
  const width = fullWidth ? "" : "max-w-(--breakpoint-xl) p-4 md:p-8";

  if (loading) {
    return (
      <Center className={cn("h-full flex-1", className)}>
        <div className="flex flex-col items-center gap-4">
          <Circles loading={loading} />
          <TypewriterText text={loadingMessage} />
        </div>
      </Center>
    );
  }

  if (permissionLocked && !loading) {
    return (
      <Column
        id={id}
        className={cn("flex-1 w-full h-full items-center", className)}
      >
        <NoRights />
      </Column>
    );
  }

  return (
    <Column
      id={id}
      className={cn("flex-1 w-full h-full items-center", className)}
    >
      <Column
        className={cn(
          "flex-1 w-full transition-all overflow-visible",
          width,
          contentClassName
        )}
        {...rest}
      >
        {children}
      </Column>
    </Column>
  );
}

export { ScreenContainer };
